// extracted by mini-css-extract-plugin
export default {"title":"LongDistanceTitle_title__ECf+L"};